import { STORAGE_KEYS, services } from '@nvision/oidc';

export const initOIDCAuth = () => {
  const isKeyExists = localStorage.getItem(STORAGE_KEYS.isProviderDisabled) !== null;
  if (isKeyExists) {
    return;
  }
  services.auth.disableOIDCProvider();
  return;
};
